export default __webpack_public_path__ + "static/weaving-9227f506f7864e1d69a6478344fe6bb9.webp";